const PATH = Object.freeze({
  ACCOUNT: 'account',
  TXS_DETAIL: 'transactions/detail',
});

export default Object.freeze({
  PATH,
  URL: process.env.VUE_APP_EXPLORER_URL,
});
